/**
 * DevelopmentTab Component
 * 
 * Employee development/IDP tab content.
 * Wraps EmployeeIDPView for consistent tab layout.
 */

import { EmployeeIDPView } from '@/components/performance/development/EmployeeIDPView'
import type { EmployeePerformancePlan } from '@/services/api/performanceService'

interface DevelopmentTabProps {
  userId: string | null
  numericUserId?: number
  selectedYear: number
  userRole: 'employee' | 'manager'
  performancePlan: EmployeePerformancePlan | null
}

export function DevelopmentTab({
  userId,
  numericUserId,
  selectedYear,
  userRole,
  performancePlan
}: DevelopmentTabProps) {
  if (!userId) {
    return (
      <div className="bg-white rounded-xl p-6 shadow-sm text-center">
        <p className="text-gray-600">Loading user information...</p>
      </div>
    )
  }

  return (
    <EmployeeIDPView
      userId={userId}
      numericUserId={numericUserId}
      year={selectedYear}
      embedded={true}
      userRole={userRole}
      performancePlan={performancePlan}
    />
  )
}

export default DevelopmentTab
